import { Component, input } from '@angular/core';
import type { MissionStatusCode } from '@killer-party/contracts';
import { missionStatusLabel } from '../../domain/labels';

export interface RosterEntry {
  firstName: string;
  codeName: string;
  statusCode: MissionStatusCode;
}

// Fiche d'effectif : un agent par ligne. Jamais montree a un joueur encore en jeu (TD-021).
@Component({
  selector: 'app-roster',
  styleUrl: './roster.scss',
  templateUrl: './roster.html',
})
export class Roster {
  readonly entries = input.required<RosterEntry[]>();
  readonly selfCodeName = input<string | null>(null);
  readonly count = input.required<string>();

  protected isOut(entry: RosterEntry): boolean {
    return entry.statusCode === 'FAILED' || entry.statusCode === 'ABORTED';
  }

  protected label(entry: RosterEntry): string {
    return missionStatusLabel(entry.statusCode);
  }
}
